import actorMigrations from "@-/dev.improve.haniverse.database.schemas.actor.migrations";
import onetime from "@-/com.npmjs.onetime";

/**
 * Every actor migration this bundle carries, oldest first. Tags start with a UTC timestamp
 * (`YYYYMMDDHHMMSS_name`), so lexical order is chronological order.
 *
 * The same list describes three things that must agree: the app's local schema, what the server
 * can migrate a user's cloud database to, and what a release may assume the deployed server has.
 */
export const getBundledActorMigrationTags = onetime((): readonly string[] =>
  Object.keys(actorMigrations.migrations).sort(),
);

/** Tags in `required` that `available` lacks, in order. Empty means `available` is sufficient. */
export function findMissingActorMigrationTags(
  available: readonly string[],
  required: readonly string[] = getBundledActorMigrationTags(),
): string[] {
  const have = new Set(available);
  return required.filter((tag) => !have.has(tag));
}
